import { TranslatedText, translatedTextSchema } from "../core/TranslatedText";
import * as zod from "zod";

export interface CustomerType {
  id: number;
  translations: TranslatedText[];
}

export const customerTypeSchema = zod.object({
  id: zod.number().nonnegative(),
  translations: zod.array(translatedTextSchema),
});
